import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '@canvas-logic/clp-shared-ui';

/**
 * ADR-0075 §Compatibility: the platform's resolved language is authoritative.
 * `useLanguageSwitcher` writes the REQUESTED one (it runs before any response
 * exists), so correct both the document and the bundled UI catalog here —
 * otherwise a rejected language leaves product labels and chrome disagreeing.
 */
export function ResolvedLanguage(): null {
  const { resolvedLanguage } = useLocalization();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!resolvedLanguage) return;
    document.documentElement.lang = resolvedLanguage;
    // A language with no bundled catalog falls through i18next's own fallback.
    if (i18n.language !== resolvedLanguage) void i18n.changeLanguage(resolvedLanguage);
  }, [resolvedLanguage, i18n]);

  return null;
}
